import { takeLatest, takeEvery, all, put } from 'redux-saga/effects'
import { map, flatten, forEach } from 'lodash'
import { Carts, CartItems, Contacts, Users, VideoPlayers } from '@gratify-eu/entities'
import i18n from 'i18next'

import { actions as configActions, saveConfig, retrieveConfig, clearConfig } from '~/config'

function createSaveConfigWorker(name, valueKey) {
  return function * (action) {
    const value = (action.payload || {})[valueKey];
    saveConfig(name, value);
  }
}

function createClearConfigWorker(name) {
  return function * (action) {
    clearConfig(name);
  }
}

function * handleSuccessWorker (action) {
  const {response} = action.payload || {}

  if (response && response.newToken) {
    yield put(configActions.setCustomerToken(response.newToken));
  }
}

function * handleSetConfig (action) {
  const { localeConfig } = action.payload  || {};

  if(localeConfig) {
    forEach(localeConfig, (value, key) => {
      i18n.addResourceBundle(key, 'cart', value);
    })

  }
}

export default function * rootSaga () {
  const allCustomerTokenActions = flatten(map([Carts, CartItems, Contacts, Users, VideoPlayers], (entity) => {
    return [
      entity.actions.fetch.success,
      entity.actions.fetchList.success,
      entity.actions.update.success,
      entity.actions.create.success,
      entity.actions.del.success,
      entity.actions.options.success,
    ]
  }));
  yield all([
    takeLatest(configActions.setCartId, createSaveConfigWorker('cartId', 'id')),
    takeLatest(configActions.setCustomerToken, createSaveConfigWorker('customerToken', 'token')),
    takeLatest(configActions.setUserTokens, createSaveConfigWorker('userTokens', 'tokens')),
    takeLatest(configActions.clearActiveCart, createClearConfigWorker('cartId')),
    takeLatest(configActions.clearCustomerToken, createClearConfigWorker('customerToken')),
    takeLatest(configActions.clearUserTokens, createClearConfigWorker('userTokens')),
    takeLatest(configActions.clearRedirectUrl, createClearConfigWorker('redirectAfterAuth')),
    takeLatest(configActions.setRedirectUrl, createSaveConfigWorker('redirectAfterAuth', 'url')),
    takeLatest(configActions.setConfig, handleSetConfig),
    takeEvery(allCustomerTokenActions, handleSuccessWorker)
  ])
}
